import React, { useState, useEffect, useContext } from "react";
import { APIContext } from "src/components/Contexts/APIContext";
import SelectChip from "../../Filtering/Chips/SelectChip";
import QaiChallengeFilterViewModel from "./ViewModels/QaiChallengeFilterViewModel";

interface IQaiSectionsChipProps {
    removeFilter: (filterFlag: string, filterNames?: string[]) => void;
    filters: QaiChallengeFilterViewModel
    setFilterValue: (filterName: string, value: any) => void;
    templateName: string
}

export default function QaiSectionsChip({ removeFilter, filters, setFilterValue, templateName }: IQaiSectionsChipProps) {
    const { get } = useContext(APIContext);
    const [sections, setSections] = useState<string[]>([]);

    useEffect(() => {
        if (templateName) {
            get('QaiScorecardChallenge',
                `GetSections?templateName=${templateName}`,
                (data) => setSections(data))
        }
    }, [templateName])

    return (
        <SelectChip
            removeFilter={removeFilter}
            filterFlag="flagSection"
            filterNames={["section"]}
            show={filters.flagSection}
            title="Section"
            currentSelection={filters.section}
            onSelect={setFilterValue}
            filterName="section"
            client={filters.client}
            options={sections}
            isAgent={false} />
    )
}